import { defaultCtx } from "~/lib/AjaxCtx"

export function makeDefaultState() {
    return {
        /**
         * cookiesValues Structure:
         *    hasAccepted: Boolean
         *    description: String
         *    id: Number
         *    isOptional: Boolean
         *    name: String
         */
        cookiesValues: [],
        shouldISendCookies: false,
    }
}

export const getters = {
    googleAnalyticsIsEnabled: (state, _getters, rootState) => {
        const { googleAnalyticsAccount } = rootState.configs
        return (
            !!googleAnalyticsAccount &&
            state.cookiesValues.some(
                ({ key, hasAccepted }) =>
                    key === "analyticalCookies" && hasAccepted
            )
        )
    },
}

export const mutations = {
    acceptOptionalCookies({ cookiesValues }) {
        cookiesValues
            .filter(({ isOptional }) => isOptional)
            .map(cookie => {
                cookie.hasAccepted = true
            })
    },

    rejectOptionalCookies({ cookiesValues }) {
        cookiesValues
            .filter(({ isOptional }) => isOptional)
            .map(cookie => {
                cookie.hasAccepted = false
            })
    },

    setShouldISendCookies(state, value) {
        state.shouldISendCookies = value
    },

    setCookies(state, cookies) {
        state.cookiesValues = cookies
    },

    toggleCookie({ cookiesValues }, id) {
        const targetCookie = cookiesValues.find(cookies => cookies.id == id)
        if (!targetCookie)
            throw new Error(`Cookie with id: ${id} was not found`)
        targetCookie.hasAccepted = !targetCookie.hasAccepted
    },
}

export function makeActions(ctx) {
    return {
        accept({ commit }) {
            commit("acceptOptionalCookies")
            commit("setShouldISendCookies", true)
        },

        toggle({ commit }, id) {
            commit("toggleCookie", id)
        },

        reject({ commit }) {
            commit("rejectOptionalCookies")
            commit("setShouldISendCookies", true)
        },

        async refresh({ commit, dispatch, rootGetters }) {
            const hasSession = !!rootGetters.currentUser
            const url = hasSession ? "/cookies" : "/cookies/all"

            try {
                const cookies = await ctx.fetchData(url)
                commit("setCookies", cookies)
            } catch (error) {
                dispatch(
                    "pushNotification",
                    {
                        title: error.message,
                        type: "danger",
                    },
                    { root: true }
                )
            }
        },

        async save({ state, commit, dispatch }) {
            if (!state.shouldISendCookies) {
                await dispatch("refresh")
                return
            }

            const cookies = state.cookiesValues.map(cookie => {
                const { hasAccepted, isOptional } = cookie
                // mandatory cookies are always accepted
                // hasAccepted is null by default and we need to cast it into boolean (only affecting optional cookies)
                return {
                    ...cookie,
                    hasAccepted: !isOptional || !!hasAccepted,
                }
            })

            await ctx.fetchData("/cookies", {
                method: "POST",
                body: JSON.stringify(cookies),
            })
            commit("setShouldISendCookies", false)
        },
    }
}

export default {
    namespaced: true,
    state: makeDefaultState(),
    getters,
    mutations,
    actions: makeActions(defaultCtx),
}
